import React from 'react'
import cn from 'classnames'
import styles from 'components/shared/icons/icons.module.scss'
import { LockKeyhole } from 'lucide-react'

export default function PrivateIcon(props) {
    const { contextStyles, hoverStyles, selectedStyles } = props
    return (
        <div className={cn(styles.iconComp, contextStyles, hoverStyles, selectedStyles)}>
            <LockKeyhole />
        </div>
    )
}
